(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.getElementById('upphaar-announcement-track');
    if (!track) return;
    var items = track.querySelectorAll('.upphaar-announcement__item');
    if (items.length < 2) return;
    var index = 0;
    var interval = (parseInt(track.getAttribute('data-rotation'), 10) || 4) * 1000;
    setInterval(function () {
      index = (index + 1) % items.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
    }, interval);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('upphaar-cart-drawer');
    if (!drawer) return;

    var FREE_SHIPPING_THRESHOLD = (parseInt(drawer.getAttribute('data-free-shipping'), 10) || 500) * 100;
    var EMPTY_TEXT = drawer.getAttribute('data-empty-text') || 'Your bag is empty.';
    var REMOVE_LABEL = drawer.getAttribute('data-remove-label') || 'Remove';
    var PROGRESS_PREFIX = drawer.getAttribute('data-progress-prefix') || 'Add';
    var PROGRESS_LABEL = drawer.getAttribute('data-progress-label') || 'more for complimentary shipping';
    var PROGRESS_SUCCESS = drawer.getAttribute('data-progress-success') || 'Congratulations! Complimentary shipping unlocked.';

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return '₹' + value;
    }

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      loadCart();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    window.UpphaarCartDrawer = { open: open, close: close, refresh: loadCart, addToCart: addToCart };

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // --- Global AJAX add-to-cart -------------------------------------------
    // Intercepts any form that submits to /cart/add (product form, collection
    // quick-add cards, etc.) and adds the item via AJAX so the cart drawer
    // opens instantly with feedback instead of a full page reload.
    function addToCart(form, e) {
      if (!form) return Promise.resolve(false);
      if (e && e.preventDefault) e.preventDefault();
      var btn = form.querySelector('[type="submit"], button[type="submit"]');
      if (btn) { btn.disabled = true; }

      var body;
      // Use FormData so file inputs (personalization photo) are handled too.
      try {
        body = new FormData(form);
      } catch (err) {
        body = new URLSearchParams(new FormData(form)).toString();
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        body: body
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (data) { throw data; });
          return r.json();
        })
        .then(function (item) {
          if (btn) btn.disabled = false;
          refreshHeaderCountFromCart();
          loadCart();
          open();
          return item;
        })
        .catch(function (err) {
          if (btn) btn.disabled = false;
          if (err && err.description) {
            alert(err.description);
          } else {
            alert('Could not add this item to your bag. Please try again.');
          }
          return false;
        });
    }

    function refreshHeaderCountFromCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { refreshHeaderCount(cart.item_count); })
        .catch(function () {});
    }

    // Bind all existing add-to-cart forms on page load and use a MutationObserver
    // so forms rendered dynamically later still get AJAX behavior.
    function bindAjaxAddToCart() {
      document.querySelectorAll('form[action*="/cart/add"], form.upphaar-card__form, form#upphaar-product-form')
        .forEach(function (form) {
          if (form.dataset.ajaxBound) return;
          form.dataset.ajaxBound = 'true';
          form.addEventListener('submit', function (e) {
            // Line-item FILE uploads (personalization photos) are NOT supported by
            // the /cart/add.js AJAX endpoint — they need the native multipart POST
            // to /cart/add. If a file is selected, let the form submit normally
            // (full page reload) so the actual image gets uploaded to the order.
            var fileInputs = form.querySelectorAll('input[type="file"]');
            var hasFile = false;
            for (var i = 0; i < fileInputs.length; i++) {
              if (fileInputs[i].files && fileInputs[i].files.length) { hasFile = true; break; }
            }
            if (hasFile) return; // allow native (server-side) submit
            e.preventDefault();
            addToCart(form, e);
          });
        });

      // The generic Shopify product form posts to /cart/add.
      // Ensure it is bound after any re-render.
      var productForm = document.getElementById('upphaar-product-form');
      if (productForm && !productForm.dataset.ajaxBound) {
        productForm.dataset.ajaxBound = 'true';
        productForm.addEventListener('submit', function (e) {
          e.preventDefault();
          addToCart(productForm, e);
        });
      }
    }
    bindAjaxAddToCart();

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () { bindAjaxAddToCart(); });
      try {
        observer.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    function loadCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    function render(cart) {
      var countEl = drawer.querySelector('[data-cart-count]');
      if (countEl) countEl.textContent = cart.item_count;

      var itemsEl = drawer.querySelector('[data-cart-items]');
      if (!itemsEl) return;

      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="upphaar-drawer__empty">' + EMPTY_TEXT + '</p>';
        var subtotal = drawer.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = '₹0';
      } else {
        itemsEl.innerHTML = cart.items.map(function (item) {
          var img = item.image
            ? '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '"') + '" loading="lazy">'
            : '';
          var options = '';
          if (item.options && item.options.length) {
            options = item.options.join(' / ');
          }
var props = '';
          if (item.properties) {
            Object.keys(item.properties).forEach(function (k) {
              var v = item.properties[k];
              if (v && k.indexOf('_') !== 0 && k !== 'Foil Color' && k !== 'Customization') {
                props += '<p class="upphaar-drawer__item-options">' + k + ': ' + v + '</p>';
              }
            });
            // Show customization summary nicely
            if (item.properties['Customization'] === 'true') {
              var details = [];
              if (item.properties['Foil Color']) details.push('Foil: ' + item.properties['Foil Color']);
              if (item.properties['Engraving']) details.push('Engraving: ' + item.properties['Engraving']);
              if (item.properties['Reference Image']) details.push('Ref: ' + item.properties['Reference Image']);
              if (details.length) {
                props += '<p class="upphaar-drawer__item-options upphaar-drawer__item-custom">' +
                  '<i class="fa-solid fa-wand-magic-sparkles" aria-hidden="true"></i> ' + details.join(' · ') +
                '</p>';
              }
            }
          }
          return (
            '<div class="upphaar-drawer__item" data-key="' + item.key + '">' +
              '<div class="upphaar-drawer__item-media">' + img + '</div>' +
              '<div class="upphaar-drawer__item-info">' +
                '<a class="upphaar-drawer__item-title" href="' + item.url + '">' + (item.product_title || item.title) + '</a>' +
                (options ? '<p class="upphaar-drawer__item-options">' + options + '</p>' : '') +
                props +
                '<div class="upphaar-drawer__item-bottom">' +
                  '<div class="upphaar-drawer__item-qty">' +
                    '<button type="button" class="upphaar-drawer__qty-btn" data-change-qty="' + item.key + '" data-delta="-1"><i class="fa-solid fa-minus"></i></button>' +
                    '<input type="number" value="' + item.quantity + '" data-qty-input="' + item.key + '" min="0">' +
                    '<button type="button" class="upphaar-drawer__qty-btn" data-change-qty="' + item.key + '" data-delta="1"><i class="fa-solid fa-plus"></i></button>' +
                  '</div>' +
                  '<span class="upphaar-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
                '</div>' +
                '<button type="button" class="upphaar-drawer__item-remove" data-change-qty="' + item.key + '" data-delta="-1000">' + REMOVE_LABEL + '</button>' +
              '</div>' +
            '</div>'
          );
        }).join('');

        var subtotal = drawer.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
      }

      updateProgress(cart);
      bindQtyButtons();
    }

    function updateProgress(cart) {
      var fill = drawer.querySelector('[data-progress-fill]');
      var text = drawer.querySelector('[data-progress-text]');
      if (!fill || !text) return;
      var subtotal = cart.items_subtotal_price || 0;
      var remaining = FREE_SHIPPING_THRESHOLD - subtotal;
      var pct = Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100));

      if (remaining > 0) {
        fill.style.width = pct + '%';
        text.textContent = PROGRESS_PREFIX + ' ' + formatMoney(remaining) + ' ' + PROGRESS_LABEL;
      } else {
        fill.style.width = '100%';
        text.textContent = PROGRESS_SUCCESS;
      }
    }

    function bindQtyButtons() {
      // Use event delegation on the items container so listeners are attached
      // once and survive re-renders (avoids duplicate handler accumulation).
      var itemsEl = drawer.querySelector('[data-cart-items]');
      if (!itemsEl || itemsEl.dataset.bound) return;
      itemsEl.dataset.bound = 'true';

      itemsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-change-qty]');
        if (!btn) return;
        var key = btn.getAttribute('data-change-qty');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        updateQty(key, delta);
      });

      itemsEl.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (!input) return;
        var key = input.getAttribute('data-qty-input');
        var val = parseInt(input.value, 10) || 0;
        updateQty(key, val);
      });
    }

    function updateQty(key, deltaOrVal) {
      // Get current cart to compute new qty
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) return;
        var qty = item.quantity + deltaOrVal;
        if (qty < 0) qty = 0;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
      }).then(function (r) {
        if (!r) return;
        return r.json();
      }).then(function (cart) {
        if (cart) { render(cart); refreshHeaderCount(cart.item_count); }
      }).catch(function () {});
    }

    function refreshHeaderCount(count) {
      var el = document.querySelector('.upphaar-header__cart-count');
      if (!el) return;
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Gift note toggle
    const giftToggle = document.getElementById('upphaar-gift-toggle');
    const giftOptions = document.getElementById('upphaar-gift-options');
    if (giftToggle && giftOptions) {
      giftToggle.addEventListener('change', function () {
        giftOptions.classList.toggle('is-open', giftToggle.checked);
      });
    }

    // Qty +/- buttons
    function changeQty(line, delta) {
      const input = document.querySelector('.upphaar-cart__qty-input[data-line="' + line + '"]');
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      val = Math.max(0, val + delta);
      input.value = val;
      // Auto-submit update form when reaching 0 to remove item.
      if (val === 0) {
        const form = input.closest('form');
        if (form) {
          const updateBtn = form.querySelector('input[type="submit"][name="update"], button[name="update"]');
          if (updateBtn) updateBtn.click();
        }
      }
    }
    document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.getAttribute('data-line'), -1); });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.getAttribute('data-line'), 1); });
    });
    document.querySelectorAll('.upphaar-cart__qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        let val = parseInt(input.value, 10) || 1;
        if (val < 0) val = 0;
        input.value = val;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.UpphaarCollection = window.UpphaarCollection || {
      toggleFilters: function () {
        const drawer = document.getElementById('upphaar-filter-drawer');
        if (!drawer) return;
        drawer.classList.toggle('is-open');
        drawer.setAttribute('aria-hidden', drawer.classList.contains('is-open') ? 'false' : 'true');
        document.body.style.overflow = drawer.classList.contains('is-open') ? 'hidden' : '';
      }
    };

    document.addEventListener('click', function (e) {
      // Session-based tag filtering: append selected tags to the collection URL.
      const checkbox = e.target.closest('.upphaar-collection__filter-option input[type="checkbox"]');
      if (!checkbox) return;
      const baseUrl = window.location.origin + window.location.pathname;
      const params = new URLSearchParams(window.location.search);

      // Collect all checked tags from this filter session.
      const checked = [];
      document.querySelectorAll('.upphaar-collection__filter-option input[type="checkbox"]:checked').forEach(function (cb) {
        const raw = cb.getAttribute('data-value') || cb.value;
        checked.push(raw);
      });

      if (checked.length) {
        params.set('constraint', checked.join(' OR '));
      } else {
        params.delete('constraint');
      }
      const qs = params.toString();
      window.location = qs ? baseUrl + '?' + qs : baseUrl;
    });

    // Sort by select handler
    const sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortSelect.value);
        window.location = window.location.pathname + '?' + params.toString();
      });
    }

    // Collapsible filter groups
    document.addEventListener('click', function (e) {
      const head = e.target.closest('.upphaar-collection__filter-head');
      if (!head) return;
      const body = head.nextElementSibling;
      const icon = head.querySelector('i');
      if (!body) return;
      const isHidden = body.style.display === 'none';
      body.style.display = isHidden ? 'flex' : 'none';
      if (icon) {
        icon.className = isHidden ? 'fa-solid fa-minus' : 'fa-solid fa-plus';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const el = document.querySelector('.upphaar-sale [data-countdown]');
    if (!el) return;
    const target = el.getAttribute('data-countdown');
    let end = new Date(target).getTime();
    if (isNaN(end)) {
      // Fallback: 96 hours from now
      end = Date.now() + 96 * 60 * 60 * 1000;
    }
    const hoursEl = el.querySelector('[data-hours]');
    const minsEl = el.querySelector('[data-minutes]');
    const secsEl = el.querySelector('[data-seconds]');

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function tick() {
      const diff = end - Date.now();
      if (diff <= 0) {
        clearInterval(interval);
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        return;
      }
      const totalSecs = Math.floor(diff / 1000);
      const hours = Math.floor(totalSecs / 3600);
      const mins = Math.floor((totalSecs % 3600) / 60);
      const secs = totalSecs % 60;
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    tick();
    const interval = setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    window.UpphaarHeader = window.UpphaarHeader || {
      toggleMobileMenu: function () {
        const menu = document.getElementById('upphaar-mobile-menu');
        if (!menu) return;
        menu.classList.toggle('is-open');
        menu.setAttribute('aria-hidden', menu.classList.contains('is-open') ? 'false' : 'true');
        document.body.style.overflow = menu.classList.contains('is-open') ? 'hidden' : '';
      }
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.upphaar-hero').forEach(function (hero) {
    const slides = hero.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    const dots = hero.querySelectorAll('[data-dot]');
    let current = 0;
    let timer;

    function show(index) {
      slides.forEach(s => (s.setAttribute('hidden', '')));
      slides[index].removeAttribute('hidden');
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      current = index;
    }

    function next() {
      show((current + 1) % slides.length);
    }
    function prev() {
      show((current - 1 + slides.length) % slides.length);
    }
    function reset() {
      clearInterval(timer);
      if (hero.dataset.autoplay === 'false') return;
      timer = setInterval(next, Number(hero.dataset.interval || 5) * 1000);
    }

    const nextBtn = hero.querySelector('[data-next]');
    const prevBtn = hero.querySelector('[data-prev]');
    if (nextBtn) nextBtn.addEventListener('click', () => { next(); reset(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); reset(); });
    dots.forEach((d, i) => d.addEventListener('click', () => { show(i); reset(); }));

    reset();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    // Toggle the "add new address" form
    const newToggle = document.querySelector('[data-address-new-toggle]');
    const newForm = document.querySelector('[data-address-new-form]');
    if (newToggle && newForm) {
      newToggle.addEventListener('click', function () {
        newForm.hidden = !newForm.hidden;
      });
    }
    const newCancel = document.querySelector('[data-address-new-cancel]');
    if (newCancel && newForm) {
      newCancel.addEventListener('click', function () {
        newForm.hidden = true;
      });
    }

    // Toggle edit forms per address
    document.addEventListener('click', function (e) {
      const editToggle = e.target.closest('[data-address-edit-toggle]');
      if (editToggle) {
        const id = editToggle.getAttribute('data-address-edit-toggle');
        const form = document.querySelector('[data-address-edit-form="' + id + '"]');
        if (form) form.hidden = !form.hidden;
        return;
      }
      const editCancel = e.target.closest('[data-address-edit-cancel]');
      if (editCancel) {
        const id = editCancel.getAttribute('data-address-edit-cancel');
        const form = document.querySelector('[data-address-edit-form="' + id + '"]');
        if (form) form.hidden = true;
        return;
      }
      const del = e.target.closest('[data-address-delete]');
      if (del) {
        const id = del.getAttribute('data-address-delete');
        if (!id) return;
        const confirmed = window.confirm('Delete this address?');
        if (!confirmed) return;
        Shopify.postLink('/account/addresses/' + id, { parameters: { _method: 'delete' } });
      }
    });

    // Country -> province dropdown sync for all address forms
    function initProvinceSync(formId) {
      const countrySelect = document.getElementById('AddressCountry_' + formId);
      const provinceSelect = document.getElementById('AddressProvince_' + formId);
      if (!countrySelect || !provinceSelect) return;
      if (window.Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('AddressCountry_' + formId, 'AddressProvince_' + formId, {
          hideElement: 'AddressProvince_' + formId
        });
      }
    }

    // New address form
    initProvinceSync('New');

    // Edit forms
    document.querySelectorAll('[data-country-form-id]').forEach(function (countrySelect) {
      initProvinceSync(countrySelect.getAttribute('data-country-form-id'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.UpphaarContact = window.UpphaarContact || {
      trackOrder: function () {
        const input = document.getElementById('upphaar-tracking-input');
        const error = document.getElementById('upphaar-track-error');
        const result = document.getElementById('upphaar-tracking-result');
        const displayId = document.getElementById('upphaar-display-order-id');
        const progress = document.getElementById('upphaar-progress-bar');
        if (!input || !error || !result) return;

        const val = input.value.trim();
        if (!val) {
          error.hidden = false;
          result.hidden = true;
          return;
        }
        error.hidden = true;
        displayId.textContent = val.toUpperCase();
        result.hidden = false;
        progress.style.width = '0%';
        setTimeout(function () {
          progress.style.width = '38%';
        }, 100);
      }
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const head = e.target.closest('.upphaar-faq__head');
    if (!head) return;
    const item = head.closest('.upphaar-faq__item');
    if (!item) return;
    item.classList.toggle('is-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('.upphaar-auth__password-toggle');
    if (!toggle) return;
    const id = toggle.getAttribute('data-password-toggle');
    const input = document.getElementById(id);
    if (!input) return;
    const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
    input.setAttribute('type', type);
    const icon = toggle.querySelector('i');
    icon.className = type === 'password' ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('.upphaar-auth__password-toggle');
    if (!toggle) return;
    const id = toggle.getAttribute('data-password-toggle');
    const input = document.getElementById(id);
    if (!input) return;
    const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
    input.setAttribute('type', type);
    const icon = toggle.querySelector('i');
    icon.className = type === 'password' ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var customerId = document.body && document.body.getAttribute('data-customer-id');
    var KEY = customerId ? 'upphaar_wishlist_' + customerId : 'upphaar_wishlist_guest';
    var grid = document.getElementById('upphaar-wishlist-grid');
    var loadingEl = document.getElementById('upphaar-wishlist-loading');
    var emptyEl = document.getElementById('upphaar-wishlist-empty');
    var section = document.querySelector('.upphaar-wishlist');
    if (!grid || !section) return;
    var addBtnLabel = (section.getAttribute('data-add-btn-label') || 'Add to Privilege Bag').trim();

    function getWishlist() {
      try {
        var stored = window.localStorage.getItem(KEY);
        // One-time migration from the older global wishlist key so existing
        // customer selections are not silently lost after customer scoping.
        if (!stored) {
          var legacy = window.localStorage.getItem('upphaar_wishlist');
          if (legacy) {
            window.localStorage.setItem(KEY, legacy);
            stored = legacy;
          }
        }
        return JSON.parse(stored || '[]');
      } catch (e) { return []; }
    }
    function setWishlist(list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      // Keep header badge in sync.
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        var n = el.querySelector('.upphaar-wishlist-count');
        if (n) n.textContent = list.length;
      });
    }

    function money(value) {
      // value is a string price from the product.js payload (e.g. "4900").
      var num = parseFloat(value) || 0;
      return '₹' + num.toLocaleString('en-IN');
    }

    function buildCard(product) {
      var card = document.createElement('div');
      card.className = 'upphaar-wishlist__card';
      card.setAttribute('data-handle', product.handle);

      var image = product.featured_image || product.images[0];
      var mediaHtml = '<div class="upphaar-wishlist__media upphaar-wishlist__media--fallback"><i class="fa-regular fa-image" aria-hidden="true"></i></div>';
      if (image) {
        mediaHtml = '<a href="' + product.url + '" class="upphaar-wishlist__media"><img src="' + image + '" alt="' + (product.title || '').replace(/"/g, '"') + '" loading="lazy"></a>';
      }

      var compare = '';
      if (product.compare_at_price && parseInt(product.compare_at_price, 10) > parseInt(product.price, 10)) {
        compare = '<span class="upphaar-wishlist__compare">' + money(product.compare_at_price) + '</span>';
      }

      card.innerHTML =
        '<button type="button" class="upphaar-wishlist__remove" data-handle="' + product.handle + '" aria-label="Remove from wishlist"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>' +
        mediaHtml +
        '<div class="upphaar-wishlist__body">' +
          '<a href="' + product.url + '" class="upphaar-wishlist__name">' + (product.title || '') + '</a>' +
          '<p class="upphaar-wishlist__vendor">' + (product.vendor || '') + '</p>' +
          '<span class="upphaar-wishlist__price">' + money(product.price) + compare + '</span>' +
'<button type="button" class="upphaar-wishlist__add" data-add-handle="' + product.handle + '"><i class="fa-solid fa-bag-shopping" aria-hidden="true"></i> ' + addBtnLabel + '</button>' +
        '</div>';

      return card;
    }

    function render(list) {
      grid.innerHTML = '';
      if (!list.length) {
        if (loadingEl) loadingEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = '';
        return;
      }
      if (emptyEl) emptyEl.style.display = 'none';
      if (loadingEl) loadingEl.style.display = 'none';

      list.forEach(function (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) {
            if (!product) return;
            grid.appendChild(buildCard(product));
          })
          .catch(function () {});
      });
    }

    // Remove from wishlist
    grid.addEventListener('click', function (e) {
      var remove = e.target.closest('.upphaar-wishlist__remove');
      if (remove) {
        var handle = remove.getAttribute('data-handle');
        if (!handle) return;
        var list = getWishlist().filter(function (h) { return h !== handle; });
        setWishlist(list);
        render(list);
        return;
      }

      // Add to cart via product.js + cart.js
      var add = e.target.closest('.upphaar-wishlist__add');
      if (add) {
        var addHandle = add.getAttribute('data-add-handle');
        if (!addHandle) return;
        fetch('/products/' + addHandle + '.js')
          .then(function (res) { return res.json(); })
          .then(function (product) {
            var variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
            if (!variantId) return;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            });
          })
          .then(function (res) { return res ? res.json() : null; })
          .then(function () {
            if (window.UpphaarCartDrawer && window.UpphaarCartDrawer.open) {
              window.UpphaarCartDrawer.open();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {});
      }
    });

    window.addEventListener('storage', function (e) {
      if (e.key === KEY) render(getWishlist());
    });

    render(getWishlist());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var popup = document.getElementById('upphaar-popup');
    if (!popup) return;
    var key = 'upphaar_popup_' + popup.getAttribute('data-popup-id');
    var closed = false;
    try { closed = window.localStorage.getItem(key) === '1'; } catch (e) {}

    function show() {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      popup.hidden = true;
      document.body.style.overflow = '';
      try { window.localStorage.setItem(key, '1'); } catch (e) {}
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    if (closed) return;

    // Exit-intent trigger
    var shown = false;
    document.addEventListener('mouseout', function (e) {
      if (shown) return;
      if (e.relatedTarget === null && !popup.contains(e.toElement || e.target)) {
        shown = true;
        setTimeout(show, 300);
      }
    });

    // Fallback timer
    var seconds = parseInt(popup.getAttribute('data-trigger'), 10) || 30;
    setTimeout(function () {
      if (!shown) { shown = true; show(); }
    }, seconds * 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Gallery thumbnails
    const mainImg = document.getElementById('upphaar-main-image');
    const thumbs = document.querySelectorAll('#upphaar-thumbs .upphaar-product__thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) {
          mainImg.style.opacity = 0.4;
          setTimeout(function () {
            mainImg.src = thumb.getAttribute('data-src');
            mainImg.style.opacity = 1;
          }, 150);
        }
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    // Quantity buttons
    const qtyInput = document.querySelector('.upphaar-product__qty-input');
    document.querySelectorAll('.upphaar-product__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        let val = parseInt(qtyInput.value, 10) || 1;
        val += parseInt(btn.getAttribute('data-qty-change'), 10);
        val = Math.max(1, Math.min(10, val));
        qtyInput.value = val;
      });
    });

    // Accordions
    document.querySelectorAll('.upphaar-product__accordion-head').forEach(function (head) {
      head.addEventListener('click', function () {
        const acc = head.closest('.upphaar-product__accordion');
        const wasOpen = acc.classList.contains('is-open');
        document.querySelectorAll('.upphaar-product__accordion').forEach(function (a) { a.classList.remove('is-open'); });
        if (!wasOpen) acc.classList.add('is-open');
      });
    });

    // Variant selection: sync swatch radios -> hidden variant select so that
    // the form's `id` (and price) reflect the correct variant when added to cart.
    // This is the values currently chosen per option position, keyed by position.
    const radioValues = document.querySelectorAll('.upphaar-product__option-value input[type="radio"]');
    const variantSelect = document.getElementById('upphaar-variant-select');
    const priceCurrent = document.querySelector('.upphaar-product__price-current');
    const priceCompare = document.querySelector('.upphaar-product__price-compare');

    function selectedOptionValues() {
      const chosen = {};
      document.querySelectorAll('.upphaar-product__option-value input[type="radio"]:checked').forEach(function (r) {
        chosen[r.getAttribute('name')] = r.value;
      });
      return chosen;
    }

    function applyVariantSelection() {
      // Build the list of product variants from the select options' text.
      const chosen = selectedOptionValues();
      const chosenValues = Object.keys(chosen).sort().map(function (k) { return chosen[k]; });

      let match = null;
      if (variantSelect) {
        Array.prototype.forEach.call(variantSelect.options, function (opt) {
          const variantTitle = (opt.textContent || '').replace(/ - .*$/, '').trim();
          // variantTitle is like "Small / Gold" or "Default Title"
          const parts = variantTitle.split(' / ').map(function (p) { return p.trim(); });
          if (parts.length === chosenValues.length && parts.every(function (p, i) { return chosenValues[i] === p; })) {
            match = opt;
          }
        });
        if (match) {
          variantSelect.value = match.value;
          if (priceCurrent && match.getAttribute('data-price')) {
            priceCurrent.textContent = match.getAttribute('data-price');
          }
          if (priceCompare && match.getAttribute('data-compare') && match.getAttribute('data-compare') !== "") {
            priceCompare.textContent = match.getAttribute('data-compare');
            priceCompare.style.display = '';
          } else if (priceCompare) {
            priceCompare.style.display = 'none';
          }
        }
      }
    }

    radioValues.forEach(function (radio) {
      radio.addEventListener('change', function () {
        const name = radio.getAttribute('name');
        const selected = radio.value;
        document.querySelectorAll('.upphaar-product__option-values input').forEach(function (r) {
          if (r.getAttribute('name') === name && r.value === selected) r.checked = true;
        });
        applyVariantSelection();
      });
    });
    // Apply on load in case a variant is pre-selected but hidden select not synced.
    applyVariantSelection();

// Price sync when variant select changes
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        const opt = variantSelect.selectedOptions[0];
        const current = document.querySelector('.upphaar-product__price-current');
        if (current && opt) current.textContent = opt.getAttribute('data-price');
      });
    }

    // Mode toggle (Standard / Customize)
    const modeBtns = document.querySelectorAll('#upphaar-mode-toggle .upphaar-product__mode-btn');
    const customizationFlag = document.getElementById('upphaar-customization-flag');
    const personalizationFields = document.getElementById('upphaar-personalization-fields');
    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        const mode = btn.getAttribute('data-mode');
        if (mode === 'customize' && personalizationFields) {
          personalizationFields.style.display = 'block';
        } else if (personalizationFields) {
          personalizationFields.style.display = 'none';
        }
        if (customizationFlag) customizationFlag.value = mode === 'customize' ? 'true' : 'false';
      });
    });

    // Photo upload (reference image). Stores the filename as a line-item
    // property so the merchant sees which reference the customer intends.
    const uploadInput = document.getElementById('upphaar-photo-upload');
    const uploadContent = document.getElementById('upphaar-upload-content');
    const uploadSuccess = document.getElementById('upphaar-upload-success');
    const uploadFilename = document.getElementById('upphaar-upload-filename');
    const uploadZone = document.getElementById('upphaar-upload-zone');
    const uploadChange = document.getElementById('upphaar-upload-change');

    function handleFile(file) {
      const input = uploadInput;
      if (!file && input && input.files && input.files[0]) file = input.files[0];
      if (!file || !uploadFilename) return;

      // The <input type="file"> itself now carries name="properties[Reference Image]",
      // so the native multipart POST to /cart/add uploads the REAL image file.
      // (Removed the old hidden "filename-only" property input that was causing
      // only the file name — and not the actual photo — to reach the order.)
      uploadFilename.textContent = file.name;
      if (uploadContent) uploadContent.style.display = 'none';
      if (uploadSuccess) uploadSuccess.style.display = 'flex';
      // Selecting a reference photo marks this as a customized purchase.
      if (customizationFlag) customizationFlag.value = 'true';
    }

    if (uploadInput) {
      uploadInput.addEventListener('change', function () { handleFile(); });
    }
    if (uploadChange && uploadInput) {
      uploadChange.addEventListener('click', function (e) {
        e.stopPropagation();
        uploadInput.value = '';
        if (uploadContent) uploadContent.style.display = '';
        if (uploadSuccess) uploadSuccess.style.display = 'none';
        const propInput = document.getElementById('upphaar-ref-image-prop');
        if (propInput) propInput.remove();
      });
    }
    if (uploadZone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        uploadZone.addEventListener(evt, function (e) { e.preventDefault(); uploadZone.classList.add('is-dragover'); });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        uploadZone.addEventListener(evt, function (e) { e.preventDefault(); uploadZone.classList.remove('is-dragover'); });
      });
      uploadZone.addEventListener('drop', function (e) {
        handleFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
      });
    }

    // Engraving character count
    const engravingInput = document.getElementById('upphaar-engraving');
    const charCount = document.getElementById('upphaar-char-count');
    if (engravingInput && charCount) {
      engravingInput.addEventListener('input', function () {
        charCount.textContent = engravingInput.value.length + ' / ' + engravingInput.getAttribute('maxlength') + ' characters';
      });
    }

    // Recently viewed tracking (localStorage)
    (function () {
      try {
        var handleEl = document.querySelector('[data-product-handle]');
        var handle = handleEl ? handleEl.getAttribute('data-product-handle') : '';
        if (!handle) return;
        var KEY = 'upphaar_recently_viewed';
        var list = [];
        try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        list = list.slice(0, 12);
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      this.observer = new IntersectionObserver(function (entries, observer) {
        if (entries[0].isIntersecting) {
          observer.unobserve(this);
          this.fetchRecommendations();
        }
      }.bind(this), { rootMargin: '200px' });
      this.observer.observe(this);
    }
    fetchRecommendations() {
      fetch(this.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        }.bind(this))
        .catch(function () {});
    }
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-overlay"]) return;
  try {
    
  (function () {
    var search = document.getElementById('upphaar-search');
    if (!search) return;

    var input = document.getElementById('upphaar-search-input');
    var results = document.getElementById('upphaar-search-results');
    var HINT = search.getAttribute('data-hint') || 'Start typing to search...';
    var EMPTY_TEXT = search.getAttribute('data-empty-text') || 'No results found.';
    var COLLECTIONS_LABEL = search.getAttribute('data-collections-label') || 'Collections';
    var PRODUCTS_LABEL = search.getAttribute('data-products-label') || 'Products';

    function open() {
      search.classList.add('is-open');
      search.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(function () { input.focus(); }, 200);
    }
    function close() {
      search.classList.remove('is-open');
      search.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    window.UpphaarSearch = { open: open, close: close };

    search.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    if (input && results) {
      var form = document.getElementById('upphaar-search-form');
      var timer = null;

      if (form) {
        form.addEventListener('submit', function (e) {
          var q = input.value.trim();
          if (q.length < 2) { e.preventDefault(); return; }
          e.preventDefault();
          fetchSuggest(q, true);
        });
      }
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) {
          results.innerHTML = '<p class="upphaar-search__hint">' + HINT + '</p>';
          return;
        }
        timer = setTimeout(function () { fetchSuggest(q); }, 250);
      });

      function fetchSuggest(q, submitted) {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=6&section_id=search')
          .then(function (r) { return r.json(); })
          .then(function (data) { renderResults(data, submitted, q); })
          .catch(function () {
            results.innerHTML = '<p class="upphaar-search__hint">' + HINT + '</p>';
          });
      }

      function renderResults(data, submitted, q) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
        if (!products.length && !collections.length) {
          results.innerHTML = '<div class="upphaar-search__empty"><div class="upphaar-search__empty-icon"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></div><strong>No Results Found</strong><p>' + EMPTY_TEXT + '</p></div>';
          return;
        }
        // Keep the search experience inside the premium overlay.
        // A no-result query is rendered above and NEVER redirects.
        // Even when results exist, keep them visible in the same panel.
        var html = '';
        if (collections.length) {
          html += '<p class="upphaar-search__group-title">' + COLLECTIONS_LABEL + '</p>';
          collections.forEach(function (c) {
            html += '<a class="upphaar-search__product" href="' + c.url + '">' +
              '<div class="upphaar-search__product-info">' +
                '<span class="upphaar-search__product-name">' + c.title + '</span>' +
              '</div>' +
            '</a>';
          });
        }
        if (products.length) {
          html += '<p class="upphaar-search__group-title">' + PRODUCTS_LABEL + '</p>';
          products.forEach(function (p) {
            var img = p.featured_image
              ? '<img src="' + p.featured_image + '" alt="" loading="lazy">'
              : '';
            html += '<a class="upphaar-search__product" href="' + p.url + '">' +
              '<div class="upphaar-search__product-media">' + img + '</div>' +
              '<div class="upphaar-search__product-info">' +
                '<span class="upphaar-search__product-name">' + p.title + '</span>' +
                '<span class="upphaar-search__product-price">' + (p.price || '') + '</span>' +
              '</div>' +
            '</a>';
          });
        }
        results.innerHTML = html;
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
